import React from 'react';

export const DiamondIcon = () => (
	<svg width="24" height="21" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M1 7.55752L4.96992 1H12H19.0301L23 7.55752L12 20L1 7.55752Z" fill="#F0CB55" />
		<path
			d="M1 7.55752L4.96992 1M1 7.55752L12 20M1 7.55752H7.39623M4.96992 1H12M4.96992 1L7.39623 7.55752M12 1H19.0301M12 1V20M12 1L7.39623 7.55752M12 1L16.6038 7.55752M19.0301 1L23 7.55752M19.0301 1L16.6038 7.55752M23 7.55752L12 20M23 7.55752H16.6038M12 20L7.39623 7.55752M12 20L16.6038 7.55752M7.39623 7.55752H16.6038"
			stroke="#C48208"
			strokeWidth="0.5"
		/>
	</svg>
);
